import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "card custom-shadow rounded-3 bg-white border mb-4",
  style: {"padding-bottom":"18px"}
}
const _hoisted_2 = { class: "default-table-area style-three style-two top-podcasts" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-middle border-0" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "flex-shrink-0" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex-grow-1 ms-10 position-relative top-2" }
const _hoisted_9 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_10 = { class: "fs-12 text-body" }
const _hoisted_11 = { class: "fs-14 fw-medium text-secondary" }
const _hoisted_12 = { class: "fs-14 fw-medium text-secondary" }
const _hoisted_13 = { class: "ps-0 mb-0 list-unstyled d-flex gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "d-flex justify-content-between align-items-center flex-wrap gap-3 position-relative custom-padding-30",
      style: {"top":"-5px","padding-bottom":"12px"}
    }, [
      _createElementVNode("h3", { class: "mb-0 fs-18 fw-semibold" }, "Top Podcasts"),
      _createElementVNode("div", {
        class: "dropdown select-dropdown without-border position-relative",
        style: {"right":"-5px"}
      }, [
        _createElementVNode("button", {
          class: "dropdown-toggle bg-transparent border text-body rounded-2",
          style: {"padding-right":"20px"},
          role: "button",
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false"
        }, " Last 28 days "),
        _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }, [
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last 28 days ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last 48 days ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last 90 days ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Year ")
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "bg-body-bg",
                style: {"padding-top":"6.5px","padding-bottom":"6.5px"}
              }, [
                _createElementVNode("span", { class: "fs-12 fw-medium text-body" }, "Name")
              ]),
              _createElementVNode("th", {
                scope: "col",
                class: "bg-body-bg",
                style: {"padding-top":"6.5px","padding-bottom":"6.5px"}
              }, [
                _createElementVNode("span", { class: "fs-12 fw-medium text-body" }, "Episodes")
              ]),
              _createElementVNode("th", {
                scope: "col",
                class: "bg-body-bg",
                style: {"padding-top":"6.5px","padding-bottom":"6.5px"}
              }, [
                _createElementVNode("span", { class: "fs-12 fw-medium text-body" }, "Earnings")
              ]),
              _createElementVNode("th", {
                scope: "col",
                class: "bg-body-bg",
                style: {"padding-top":"6.5px","padding-bottom":"6.5px"}
              }, [
                _createElementVNode("span", { class: "fs-12 fw-medium text-body" }, "Ratings")
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.podcasts, (podcast, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: podcast.image,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h6", _hoisted_9, _toDisplayString(podcast.name), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(podcast.role), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(podcast.episodes), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(podcast.earnings), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("ul", _hoisted_13, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                      return _createElementVNode("li", { key: star }, [
                        _createElementVNode("i", {
                          class: _normalizeClass([_ctx.getStarClass(star, podcast.rating), "fs-15"])
                        }, null, 2)
                      ])
                    }), 64))
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}